module.exports = __webpack_public_path__ + "static/img/qi_5.6f8492e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_5.jpg
// module id = 5kq1
// module chunks = 1